import { FC } from 'react'
import { PageProps } from './Page1'
import Letterhead from './Letterhead'

const Page4: FC<PageProps> = ({ data }) => {
  return (
    <Letterhead data={data} pageNumber={4}>
      <p className="text">
        ۳-۸ پذیرنده متعهد می‌گردد در طول مدت قرارداد تمامی مبالغی که از کاربران
        آپولون، اعم از هزینه محصولات یا خدمات، هزینه ارسال، هزینه بسته بندی، حق
        سرویس و مالیات بر ارزش افزوده و غیره را دریافت می‌نماید، دقیقا مطابق با
        مبالغ دریافتی از مشتریان مستقیم در فروشگاه و وب سایت پذیرنده باشد، و
        مبلغ مازادی از مشتریان آپولون اخذ نگردد، و همچنین کیفیت و استاندارد ارائه
        خدمات و کالاهای عرضه شده برای کاربران آپولون دقیقا مشابه با دیگر
        خریداران باشد. در غیر این صورت آپولون مجاز به دریافت خسارت وارده به
        اعتبار خود و کاربران خود از پذیرنده می باشد. لازم به ذکر است این مبلغ می
        تواند از محل مبالغ انباشت شده بابت فروش پذیرنده در حساب آپولون نیز
        برداشت گردد.
      </p>
      <p className="text">
        ۴-۸ پذیرنده متعهد می شود مسئولیت صدور فاکتور به نام خریداران (کاربران)،
        حمل و نقل کالا در صورت نیاز، و مالیات بر ارزش افزوده در صورت شمول را
        قبول، تعهد و پرداخت نماید. لازم به ذکر است، پذیرنده بابت فروش محصولات و
        خدمات خود به کاربران نباید هیچگونه صورتحسابی برای آپولون صادر نماید. لذا
        مشخصاً تنها صورت‌حساب‌های کارمزدی که آپولون در انتهای هر ماه برای پذیرنده
        صادر می‌نماید توسط طرفین در سامانه سازمان امور مالیاتی کشور ابراز خواهد
        شد.
      </p>
      <p className="text">
        ۵-۸ آپولون هیچ‌گونه مسئولیتی در قبال مالیات برارزش‌افزوده فروشگاه در
        صورت مشمولیت پذیرنده نداشته و پذیرنده مستقیماً مسئول ثبت و پرداخت مالیات
        بر ارزش‌افزوده موارد فروش رفته به سازمان امور مالیاتی می باشد.
      </p>
      <p className="text">
        ۶-۸ پذیرنده اقرار دارد که کلیه مجوزات لازم جهت انجام تعهدات خود در این
        قرارداد را دارا بوده و تعهد می نماید که به‌طور مستمر موازین قانونی را در
        این رابطه رعایت نماید و کلیه مسئولیت های ناشی از نقض مقررات در قبال
        سازمان ها و نهادها و همچنین مشتریان و تعهدات مربوط به کالای خریداری شده
        از جمله گارانتی و ضمانت اصالت کالا صرفاً بر عهده پذیرنده می باشد.
      </p>
      <p className="text">
        ۷-۸ کلیه اطلاعات مربوط به محصولات و خدمات بر اساس اظهار پذیرنده بر روی
        پلتفرم آپولون قرارگرفته است و بدیهی است که هرگونه مسئولیت ناشی از آن از
        هرجهت و بابت، و نیز پاسخگوئی به هرگونه شکایت در رابطه با موارد فوق به
        عهده پذیرنده می باشد.
      </p>
      <p className="text">
        ۸-۸ در صورتی که مغایرتی در سفارش تحویل شده از سمت فروشگاه پذیرنده به
        کاربر آپولون وجود داشته باشد (شامل مغایرت برند، تعداد ارسال شده، تاریخ
        انقضا گذشته و ...)، پذیرنده ملزم به پرداخت خسارت وارد شده به مشتری و نیز
        پرداخت هزینه‌های اضافه ارسال کالا می‌باشد.
      </p>
      <p className="text">
        ۹-۸ پذیرنده موظف است جهت سهولت در خرید کاربران، ابزارهای تبلیغاتی را بر
        اساس طرح های ارائه‌شده توسط آپولون، در فروشگاه خود، در محل دید کاربران و
        مشتریان قرار خواهد داد.
      </p>
      <p className="text">
        ۱۰-۸ در صورت عدم رعایت بند 9-8، پذیرنده متعهد به پرداخت کمیسیون ذکر شده
        در بند 2-5 به علاوه 10 درصد دیگر به عنوان تامین هزینه‌های بازاریابی و
        خدمات ارائه‌شده خواهد بود. این مبلغ می‌تواند از محل مبالغ انباشت شده
        بابت فروش پذیرنده در حساب آپولون نیز برداشت گردد.
      </p>
    </Letterhead>
  )
}

export default Page4
